<template>
  <v-layout row wrap>
    <v-flex xs6>
      <v-alert
        :value="true"
        type="success"
      >
        Последняя синхронизация с базой данных прошла успешно в {{lastSyncDateTime | date('YYYY-MM-DD HH:mm:ss')}}
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a @click="syncEmployeeActions()">
              <v-icon dark v-on="on">refresh</v-icon>
            </a>
          </template>
          <span>Выполнить синхронизацию</span>
        </v-tooltip>
      </v-alert>
    </v-flex>
  </v-layout>
</template>

<script>
  import axios from '../../axios/axios'
  import moment from 'moment'

  export default {
    data() {
      return {
        lastSyncDateTime: ''
      }
    },
    created() {
      this.lastSyncDateTime = this.$store.getters.lastEmployeesActionsSync
    },
    methods: {
      syncEmployeeActions() {
        axios.post('employees-actions/sync-with-firebase')
        //We can't know when sync with firebird will be finished, so use this work around
        this.$store.commit('setNotification', {type: 'success', text: 'Выполнение синхронизации примерное время 1 минута'})
        this.lastSyncDateTime = moment()
      }
    }
  }
</script>
